import React from 'react';

const CompletionScreen = ({ onExit, formData }) => {
  const reference = formData?.applicationId ? `ML-${formData.applicationId}` : 'available in your dashboard';
  return (
    <div className="question-screen">
      <h1 className="question-title">Your application has been submitted</h1>

      <div className="question-content">
        <p>
          We received your pre-application. A clerk will review it before your in-person visit. Keep your application reference, <strong>{reference}</strong>, for your records.
        </p>

        <div className="usa-prose completion-next-steps">
          <h2>What happens next</h2>
          <ol>
            <li>Bring both parties and the original documents listed below to either Clerk of Court office.</li>
            <li>A clerk verifies the originals and completes the official application with you.</li>
            <li>Payment is collected in person before the license is issued.</li>
          </ol>
          <p><strong>Bring:</strong> photo IDs, certified birth certificates, Social Security information or waiver, and any required divorce decree or death certificate.</p>
        </div>

        <div className="completion-office-grid">
          <div className="completion-office-card">
            <h4>EAST BANK</h4>
            <p>Joseph S. Yenni Bldg.</p>
            <p>1221 Elmwood Park Blvd. Ste. 603</p>
            <p>Jefferson LA 70121</p>
            <p>(504) 736-6390</p>
          </div>

          <div className="completion-office-card">
            <h4>WEST BANK</h4>
            <p>General Government Bldg.</p>
            <p>200 Derbigny St. Ste. 2200</p>
            <p>Gretna LA 70053</p>
            <p>(504) 364-2922</p>
          </div>
        </div>
      </div>

      <div className="question-actions">
        <button onClick={onExit} className="btn btn-primary">
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default CompletionScreen;
